import { useContext, useEffect, useRef, useState } from "react";

import "Styles/Login.scss"
import { Box, Button, IconButton, InputAdornment, Link, TextField, Typography, styled } from "@mui/material";

// Iconosx
import VisibilityIcon from '@mui/icons-material/Visibility';
import VisibilityOffIcon from '@mui/icons-material/VisibilityOff';
import { login, loginWithGoogle, logout } from "Service/Connections";
import UserContextP from "Interfaces/Context";
import axios from "axios";
import { useNavigate } from "react-router-dom";
import Loader from "Components/Loader";

const CSSSearchField = styled(TextField)({
    "& .MuiInputBase-root": {
        color: "#000000",
        borderRadius: "20px",
        backgroundColor: "#dedcdc",
        fontFamily: "'Poppins', sans-serif",
        fontWeight: 550,
        "& input": {
            textIndent: "10px",
        },
    },
    '& label.Mui-focused': {
        color: '#173456',
        fontFamily: "'Poppins', sans-serif",
        fontWeight: 550,
    },
    '.MuiFormHelperText-root': {
        color:'red',
        fontFamily: "'Poppins', sans-serif",
        backgroundColor: "transparent",
    },
    '& label': {
        color: '#173456',
        fontFamily: "'Poppins', sans-serif",
        fontWeight: 550,
    },
    '& .MuiOutlinedInput-root': {
        '& fieldset': {
            color: '#f1f1f1',
            borderColor: '#f1f1f1',
            borderRadius: "20px"
        },
        '&:hover fieldset': {
            color: '#f1f1f1',
            borderColor: '#f1f1f1',
            borderRadius: "20px"
        },
        '&.Mui-focused fieldset': {
            color: '#f1f1f1',
            borderColor: '#f1f1f1',
            borderRadius: "20px"
        },
    },
});

const Login = () => {
    const refEmail = useRef<any>()
    const refPassword = useRef<any>()
    const context = useContext(UserContextP)
    const navigate = useNavigate()

    const [loader, setLoader] = useState(false)
    const [showPassword, setShowPassword] = useState(false);
    const [helperTextEmail, setHelperTextEmail] = useState<string>("")
    const [helperTextPassword, setHelperTextPassword] = useState<string>("")

    useEffect(()=> {
        if( context.user.email !== "" && context.authenticate.auth ) navigate("/update/order/document")

        // eslint-disable-next-line
    }, [context.user.email, context.authenticate.auth])

    const signInCrendentials = async() => { 
        setHelperTextEmail("")
        setHelperTextPassword("")
        if ( refEmail?.current?.value === "" ) {
            setHelperTextEmail("Ingrese su correo electrónico")
            return
        } 
        
        if ( refPassword?.current?.value === "" ) {
            setHelperTextPassword("Ingrese su contraseña")
            return
        }
        setLoader(true)
        let credentials:any = await login(refEmail?.current?.value, refPassword?.current?.value)
        if ( credentials?.error ) {
            setHelperTextEmail("Correo electrónico o contraseña incorrecta")
            setHelperTextPassword("Correo electrónico o contraseña incorrecta")
            setLoader(false)
            return
        }
        await axios.get(`${process.env.REACT_APP_URL_ORDER}/api/v1/auth/generate/token`, {
            headers: {
                authorization: `UserId ${ credentials.uid }`
            }
        }).then(async(response) => {
            let { user, token } = response.data.data
            if (user.role !== "admin" && user.role !== "adminsupport" && user.role !== "adminComercial" ) {
                setHelperTextEmail("Correo no cuenta con permisos suficientes.")

                await logout()
            } else {
                context.assignateAuth(credentials.uid, credentials.auth, token)
                context.assignUser(user.$key, user.last_name, user.name, user.email)
                navigate("/update/order/document")
            }
        }).catch((error) => {
            console.log(error.message)
            setHelperTextEmail("No se pudo conectar con el servidor de autenticación. Verifique su conexión o intente nuevamente.")
        }).finally(()=> {
            setLoader(false)
        })
    }

    // eslint-disable-next-line 
    const signInGoogle = async() => {
        setLoader(true)
        setHelperTextEmail("")
        let credentials:any = await loginWithGoogle()

        if ( credentials.error || !credentials.auth ) {
            setLoader(false)
            if (credentials.message && !credentials.message.includes('popup-closed-by-user')) {
                setHelperTextEmail("No se pudo iniciar sesión con Google. Intente nuevamente.")
            }
            return
        }
      
        // context.assignateAuth(credentials.uid, credentials.auth)
        let body = {
            data: {
                uid: credentials.uid,
                appVersion: "0.6.1",
                platform: "web",
                appId: "-"
            }
        }
        await axios.post(`${process.env.REACT_APP_URL_ORDER}/users/get/accounts/informationacconts`, body).then(async(response) => {
            if ( response.data.data.role !== "admin" &&  response.data.data.role !== "adminsupport" &&  response.data.data.role !== "adminComercial" ) {
                setHelperTextEmail("Correo no cuenta con permisos suficientes.")
                await logout()
            } else {
                context.assignUser(response.data.data.$key, response.data.data.last_name, response.data.data.name, response.data.data.email)
                navigate("/update/order/document")
            }
            setLoader(false)
        }).catch(async(error) => {
            setLoader(false)
            await logout()
            console.log(error.message)
            setHelperTextEmail("No se pudo conectar con el servidor de cuentas. Verifique su conexión o intente nuevamente.")
        })
    }


    return (
        <div className="root-login">
            <Loader inPage={false} redirect={true} openLoader={loader} />
            <div className="header-login">
                <img src={require("Media/Logo.png")} alt="PremierTools" style={{ borderRadius: "10px"}}/>
                <h1>Bienvenido a <span>ICC Tools</span></h1>
                <h3>Ingrese sus credenciales</h3>
            </div>
            <div className="content-login">
                <CSSSearchField
                    id="margin-none" 
                    inputRef={refEmail}
                    helperText={helperTextEmail}
                    sx={{ 
                        minWidth: "300px",
                        margin:"auto",
                        justifyContent: "center",
                    }}
                    label="Correo electrónico"
                    placeholder="example@premiertools.app"
                    onChange={() => setHelperTextEmail("")}
                />
                <CSSSearchField 
                    label="Contraseña"
                    inputRef={refPassword}
                    helperText={helperTextPassword}
                    placeholder="pass*******"
                    sx={{ 
                        minWidth: "300px",
                        margin:"auto",
                        justifyContent:"center"
                    }}
                    onChange={() => setHelperTextPassword("")}
                    type={showPassword ? "text" : "password"}
                    id="margin-none" 
                    InputProps={{
                        endAdornment: 
                            <InputAdornment position="start">
                                <IconButton onClick={()=> setShowPassword(!showPassword)}>
                                    {
                                        showPassword ?
                                        <VisibilityOffIcon /> :
                                        <VisibilityIcon />
                                    }
                                </IconButton>
                            </InputAdornment>,
                    }}
                />
                <Button
                    className='btn-app-bar'
                    onClick={signInCrendentials}>
                    Iniciar sesión
                </Button>
            </div>
            <div className="footer-login">
                <Box
                    sx={{
                        display: "inline-flex",
                        alignItems: "center",
                        gap: 1,
                        py: 0.8,
                        px: 2.2,
                        borderRadius: "30px",
                        bgcolor: "rgba(255, 255, 255, 0.75)",
                        backdropFilter: "blur(6px)",
                        border: "1px solid rgba(0, 0, 0, 0.06)",
                        boxShadow: "0 2px 8px rgba(0, 0, 0, 0.04)"
                    }}
                >
                    <Typography
                        variant="caption"
                        sx={{
                            color: "#64748b",
                            fontFamily: "-apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, Helvetica, Arial, sans-serif",
                            fontSize: "0.80rem",
                            fontWeight: 400,
                            letterSpacing: "0.4px",
                            display: "flex",
                            alignItems: "center",
                            gap: 0.6
                        }}
                    >
                        <span>Powered by</span>
                        <Link
                            href="https://thetecwave.com/"
                            target="_blank"
                            rel="noopener noreferrer"
                            underline="hover"
                            sx={{
                                color: "#112a56",
                                fontWeight: 700,
                                letterSpacing: "0.3px",
                                cursor: "pointer",
                                transition: "color 0.2s ease",
                                '&:hover': {
                                    color: "#1d4ed8"
                                }
                            }}
                        >
                            Tec Wave
                        </Link>
                        <span style={{ color: "#cbd5e1", margin: "0 3px" }}>•</span>
                        <span style={{ color: "#94a3b8" }}>Copyright © 2026</span>
                    </Typography>
                </Box>
            </div>
        </div>
    )
}

export default Login